import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, NavLink } from "react-router";
import { useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import Header from "../components/general/Header";
import ProfilPictureList from "../components/compte/ProfilPictureList";
import Popup from '../components/general/Popup';
import "../style/Sign.css";
import { X, Eye, EyeOff } from 'lucide-react';

const Sign = observer(() => {
  const profilStore = useProfilStore();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectInfo = location.state;
  const [profilPictureIsOpen, setProfilPictureIsOpen] = useState(false);
  const [errorModalPasswordIsOpen, setErrorModalPasswordIsOpen] = useState(false);
  const [errorModalMailIsOpen, setErrorModalMailIsOpen] = useState(false);

  const [pseudo, setPseudo] = useState("");
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [srcImage, setSrcImage] = useState("");
  // Bouton d'affichage des mdp
  const [showMdp, setShowMdp] = useState(false);
  const [showMdp2, setShowMdp2] = useState(false);


  // au lancement on remplis l'email si déjà renseigné dans login
  useEffect(()=>{
    if (redirectInfo?.mail) {
      setMail(redirectInfo.mail);
    }
  }, [])

  // If the user is already connected, he send him into the Home page
  useEffect(() => {
    if (profilStore.isConnected) {
      navigate("/Profil");
    }
  }, [profilStore, navigate]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password!==password2) {
      setErrorModalPasswordIsOpen(true)
      return;
    }
    try {
      await profilStore.sign(pseudo, mail, password, {profilPicture: srcImage});
      navigate("/Profil");
    } catch (error) {
      if (error.message==="mail-already-assign") {
        setErrorModalMailIsOpen(true);
      }
      throw new Error("Erreur de connexion : " + error);
    }
  };

  const handleProfilPictureChoice = (src) => {
    setSrcImage(src);
  };







  return (
    <>
      <main className="sign_main">
      <Header/>
        <div className="sign_mainContent">
          <h2 className="sign_title">S'inscrire</h2>
          <p className='sign_orderingLabel'>Les champs contenant * sont obligatoires</p>
          <form onSubmit={handleSubmit} className="sign-form">
            {srcImage && <img src={srcImage} alt="Photo de Profil" className="sign_ProfilPictureChosen"/>}
            <div className="sign_pseudoDiv">
              <input
                className="sign_pseudoInput"
                id="sign_pseudoInput"
                type="text"
                placeholder=""
                value={pseudo}
                onChange={(e) => setPseudo(e.target.value)}
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                required
              />
              <label
                htmlFor="sign_pseudoInput"
                className="sign_pseudoLabel"
                >Pseudo*</label>
            </div>
            <div className="sign_mailDiv">
              <input
                className="sign_mailInput"
                id="sign_mailInput"
                type="email"
                placeholder=""
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                required
              />
              <label
                htmlFor="sign_mailInput"
                className="sign_mailLabel"
                >Mail*
              </label>
            </div>
            <div className="sign_mdpDiv">
              <input
                className="sign_mdpInput"
                id="sign_mdpInput"
                type={showMdp?`text`:`password`}
                placeholder=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label
                htmlFor="sign_mdpInput"
                className="sign_mdpLabel"
                >Mot de passe*</label>
              <button onMouseDown={()=>setShowMdp(true)} onMouseUp={()=>setShowMdp(false)} type='button' className='sign_mdpButton'>
                {showMdp ? <EyeOff color='#fff'/> : <Eye color='#fff'/>}
              </button>
            </div>
            {/* PASSWORD V2 */}
            <div className="sign_mdpDiv">
              <input
                className="sign_mdpInput"
                id="sign_mdpInput"
                type={showMdp2?`text`:`password`}
                placeholder=""
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                required
              />
              <label
                htmlFor="sign_mdpInput"
                className="sign_mdpLabel"
                >Réécrire le Mot de passe*</label>
              <button onMouseDown={()=>setShowMdp2(true)} onMouseUp={()=>setShowMdp2(false)} type='button' className='sign_mdpButton'>
                {showMdp2 ? <EyeOff color='#fff'/> : <Eye color='#fff'/>}
              </button>
            </div>
            <button type='button' onClick={()=>setProfilPictureIsOpen(true)} className="sign_imageButton">Choisir une photo de profil</button>
            <div className='sign_signDiv'>
              <button type="submit" className="sign_connectInput">S'inscrire</button>
              <NavLink className="sign_loginButton" to={`/login`}>Se connecter</NavLink>
            </div>
          </form>
        </div>
        <Popup bodyOpenClassName="modal-profilPicture" isOpen={profilPictureIsOpen} closeModal={()=>setProfilPictureIsOpen(false)} popupTitle={"Choisir la photo de profil"}>
          <ProfilPictureList onClick={handleProfilPictureChoice} selectedPicture={srcImage}></ProfilPictureList>
        </Popup>
        <Popup bodyOpenClassName="modal-error" isOpen={errorModalPasswordIsOpen} closeModal={()=>setErrorModalPasswordIsOpen(false)} popupTitle={"Erreur dans la saisie du mot de passe"}>
          <p className='sign_errorModalText'>
            Les deux mots de passe saisie sont différents, veuillez accorder les deux.
          </p>
        </Popup>
        <Popup bodyOpenClassName="modal-error" isOpen={errorModalMailIsOpen} closeModal={()=>setErrorModalMailIsOpen(false)} popupTitle={"Mail déjà attribué"}>
          <p className='sign_errorModalText'>
            Nous avons détecté un compté déjà existant utilisant ce mail,
            si c'est le votre, vous pouvez vous connecter via le lien ci-dessous.
          </p>
          <NavLink className={"sign_errorModalRedirection"} to={"/login"} >Allez vers la page de connexion</NavLink>
        </Popup>
      </main>
    </>
  );
});

export default Sign;


